import React from "react";
import LayoutDashboard from "../../layouts/Dashboard";

const PageRad: React.FC = () => {
    return (
        <LayoutDashboard
            basePath="/rad"
            endpointDados="/rad"
        />
    )
}

export default PageRad;